import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface AhaSelectPill extends HTMLAhaSelectPillElement {}

/**
 * Pill to be used as the click target for a select list.
 *
 * @slot default - Contents of the pill
 */
@Component({
  tag: 'aha-select-pill',
  styleUrl: 'aha-select-pill.css',
  shadow: true,
})
export class AhaSelectPill {
  /**
   * The background color of the pill. Can be any CSS color string.
   */
  @Prop() color?: string;

  @Element() host!: HTMLAhaSelectPillElement;
  render() {
    return (
      <Host>
        <aha-pill color={this.color}>
          <aha-a11y-text-color>
            <slot></slot>
            <aha-icon class="select-arrows" icon="aha-icon aha-icon-sort"></aha-icon>
          </aha-a11y-text-color>
        </aha-pill>
      </Host>
    );
  }
}
